import { PublicPage } from 'api/website';

import { useContentSubsite } from './useContentSubsite';

type Props = {
  content: PublicPage;
};

export function useContentHomePageMeta({ content }: Props) {
  const subsite = useContentSubsite({ content });
  const hasHomePage = !!content.subsite.homePage;
  const subsiteHasHomePage = hasHomePage || !!subsite.homePage;
  const homePageUrl = subsite.homePage ? subsite.homePage.url : '';

  return { hasHomePage, subsiteHasHomePage, homePageUrl };
}
